import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center p-4">
      <p className="text-2xl font-semibold mb-2">Страница не найдена</p>
      <p className="text-gray-500 mb-6">
        Возможно, вы ввели неверный адрес или страница была удалена.
      </p>
      <button
        onClick={() => navigate('/')}
        className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
      >
        Вернуться на главную
      </button>
    </div>
  );
};

export default NotFoundPage;
